/**
 * AutoFollowCounterSection ("Auto-follow counter") — Settings switch for the grid scrolling to, and
 * flashing, the counter you pick in the officer card. Saved on this device (utils/autoFollowCounter).
 */
import { setAutoFollowCounter, useAutoFollowCounter } from "@/utils/autoFollowCounter";

export function AutoFollowCounterSection() {
  const on = useAutoFollowCounter();
  return (
    <label style={{ display: "flex", alignItems: "flex-start", gap: 10, cursor: "pointer", fontSize: 14, minHeight: 32 }}>
      <input
        type="checkbox"
        checked={on}
        onChange={(e) => setAutoFollowCounter(e.target.checked)}
        style={{ width: 20, height: 20, marginTop: 1, cursor: "pointer", flexShrink: 0 }}
      />
      <span>
        Scroll to the counter I pick
        <span style={{ display: "block", fontSize: 13, color: "#64748b", marginTop: 2 }}>
          When you choose a counter or change its times in an officer card, the grid scrolls it into view
          (only if it is hidden) and briefly outlines its label. Switch off if you prefer the page to stay still.
        </span>
      </span>
    </label>
  );
}
